import {Vehicle} from '../../interfaces/vehicles/vehicle';
import {VehicleCategory} from '../../interfaces/vehicles/vehicle-category';
import {VehicleClass} from '../../interfaces/vehicles/vehicle-class';
import {VehicleCategoryFactory} from './vehicle-category-factory';
import {VehicleClassFactory} from './vehicle-class-factory';
import {LightEmployeeFactory} from '../employees/light-employee-factory';
import {LightEmployee} from '../../interfaces/employees/light-employee';

export class VehicleFactory {

  /**
   *
   * @param vehicle
   */
  public static fromObject(vehicle: any): Vehicle {
    return new class implements Vehicle {
      comment: string = vehicle.comment;
      employeeId: number = vehicle.employee_id;
      employee: LightEmployee = vehicle.employee ? LightEmployeeFactory.fromObject(vehicle.employee) : null;
      id: number = vehicle.id;
      licensePlate: string = vehicle.license_plate;
      model: string = vehicle.model;
      serviceFacilityId: number = vehicle.service_facility_id;
      vehicleCategory: VehicleCategory = VehicleCategoryFactory.fromObject(vehicle.vehicle_category);
      vehicleCategoryId: number = vehicle.vehicle_category_id;
      vehicleClass: VehicleClass = VehicleClassFactory.fromObject(vehicle.vehicle_class);
      vehicleClassId: number = vehicle.vehicle_class_id;
      colorName: string = vehicle.color_name;
      name: string = vehicle.name;
    };
  }

  /**
   *
   * @param vehicle
   */
  public static toRemote(vehicle: Vehicle): any {
    return {
      comment: vehicle.comment,
      employee_id: vehicle.employeeId,
      id: vehicle.id ? vehicle.id : null,
      license_plate: vehicle.licensePlate,
      model: vehicle.model,
      service_facility_id: vehicle.serviceFacilityId,
      vehicle_category_id: vehicle.vehicleCategoryId,
      vehicle_class_id: vehicle.vehicleClassId,
      color_name: vehicle.colorName
    };
  }

  /**
   *
   * @param vehicles
   */
  public static fromArray(vehicles: any[]): Vehicle[] {
    return vehicles.map(_vehicle => VehicleFactory.fromObject(_vehicle));
  }

}
